// Scale


// Target click
var target;
$(".clickActive").on("click", function (e) {
 console.log('â');
  target = $(this).data("target");
  $(target).toggleClass("active");
  e.preventDefault();
  return false;
});
if ($(".popup .background").length > 0) {
  $(".popup .background").each(function () {
    $(this).on("click", function () {
      $(this).parent().removeClass("active");
    });
  });
}
$("body").on("click", ".MJ__close-popup", function (event) {
  //$(".popup").removeClass("active");
  // $(this).parent().parent().removeClass("active");
  $(this).closest('.MS__popup').removeClass("active");
  return false;
});

$('.clickIframe').on("click", function (e) {
  const linkIframe = $(this).data("link");
  const targetIframe = $(this).data("iframe");
  $(targetIframe).attr('src', linkIframe);
  e.preventDefault();
  return false;
});

// document.querySelector('.btn-nolayer').addEventListener("click", function(e) {
//   document.querySelector('#popup_reward').classList.remove("active");
// });


export function observe() {
  return;
  setTimeout(function () {
    $(".scrollwatch-pin").each(function () {
      var elementId = "#" + $(this).attr("id");
      var elParentId = $(this).parents('section').attr("id");

      $().scrollWatch({
        options: {
          watchOnce: false,
          watch: elementId,
          scrollThrottle: 0,
          onElementInView: function () {

            // var theChildren = $(elementId).find(".animate__onview");

            // theChildren.each(function () {
            //   // var elementAnimate = $(this).attr("data-animate");
            //   $(this).addClass("animate__animated animate__backInDown");
            //   // $(this).addClass(elementAnimate);
            // })
          },
          onElementOutOfView: function () {
            // var theChildren = $(elementId).find(".animate__onview ");
            // theChildren.each(function () {
            //   // var elementAnimate = $(this).attr("data-animate");
            //   $(this).removeClass("animate__animated animate__backInDown");
            //   // $(this).removeClass(elementAnimate);
            // });
          }
        }
      });
    });
  }, 300);

  const observeAndRemoveClass = (elementId, classToRemove, elementsToReset) => {
    try {
      const elementToObserve = document.getElementById(elementId);
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (elementToObserve.classList.contains(classToRemove)) {
              const section = elementId;
              $('#' + section).find('.animate__onview').addClass('animate__animated animate__backInDown');
              for (const element of elementsToReset) {
                $(element).removeClass(classToRemove);
                // $(elementsToReset).find('.animate__onview').removeClass('animate__animated animate__backInDown');
                $('.scrollFrameControl').removeClass('active');
                $('.scrollFrameControl[href="#' + elementId + '"]').addClass("active");
              }
            }
          }
        }
      });
      observer.observe(elementToObserve, { attributes: true });
    } catch (error) {
      console.log("Error occurred:");
    }
  };

  const classRemove = 'scroll-watch-in-view';
  observeAndRemoveClass('block_1', classRemove, ['#block_2', '#block_3', '#block_4']);
  observeAndRemoveClass('block_2', classRemove, ['#block_1', '#block_3', '#block_4']);
  observeAndRemoveClass('block_3', classRemove, ['#block_1', '#block_2', '#block_4']);
  observeAndRemoveClass('block_4', classRemove, ['#block_1', '#block_2', '#block_3']);
  // observeAndRemoveClass('block_5', classRemove, ['#block_1', '#block_2', '#block_3']);
  // observeAndRemoveClass('block_6', classRemove, ['#block_1', '#block_2', '#block_3']);
}

export function getAllUrlParams(url) {
  // get query string from url (optional) or window
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {

    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    var arr = queryString.split('&');

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split('=');

      // set parameter name and value (use 'true' if empty)
      var paramName = a[0];
      var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

      // (optional) keep case consistent
      paramName = paramName.toLowerCase();
      if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

      // if the paramName ends with square brackets, e.g. colors[] or colors[2]
      if (paramName.match(/\[(\d+)?\]$/)) {

        // create key if it doesn't exist
        var key = paramName.replace(/\[(\d+)?\]/, '');
        if (!obj[key]) obj[key] = [];

        // if it's an indexed array e.g. colors[2]
        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          var index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === 'string') {
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          // otherwise add the property
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
};

// Locate
// var locate = document.querySelector('body').classList[0];
// var url = `./assets/${locate}`;
// // var url = `https://global-mainsite.mto.zing.vn/products/metalslug/landing/2023-muachung/dist/assets/images/locate/${locate}`;
// Array.from(document.querySelectorAll('img')).forEach(function(item) {
//   if (item.dataset.js) {
//     item.src = `${url}/${item.dataset.js}`
//   };
// });